import { TOtherCancellationReasonValidation } from '../types/OtherCancellationReason';

export const OTHER_CANCELLATION_REASON_MIN_LENGTH = 15;
export const OTHER_CANCELLATION_REASON_MIN_WORDS = 2;
export const OTHER_CANCELLATION_REASON_MAX_LENGTH = 300;

export const OTHER_CANCELLATION_REASON_ERRORS = {
  notEnoughRealWords: 'Add at least two real words/15 characters',
  tooLong: `Max character count ${OTHER_CANCELLATION_REASON_MAX_LENGTH}`,
} as const;

const notEnoughRealWords: TOtherCancellationReasonValidation = {
  valid: false,
  error: OTHER_CANCELLATION_REASON_ERRORS.notEnoughRealWords,
};
const tooLong: TOtherCancellationReasonValidation = {
  valid: false,
  error: OTHER_CANCELLATION_REASON_ERRORS.tooLong,
};

// \p{M} keeps a decomposed accent ("e" + U+0301) inside its word.
const WORD = /[\p{L}\p{M}\p{N}]+(?:['’][\p{L}\p{M}\p{N}]+)*/gu;

const getWords = (text: string): string[] => text.match(WORD) ?? [];

const countDistinctWords = (words: string[]): number =>
  new Set(words.map((word) => word.toLowerCase().replace(/’/g, "'"))).size;

export const validateOtherCancellationReason = (
  text: string,
): TOtherCancellationReasonValidation => {
  const trimmed = text.trim();

  if (trimmed.length > OTHER_CANCELLATION_REASON_MAX_LENGTH) return tooLong;
  if (trimmed.length < OTHER_CANCELLATION_REASON_MIN_LENGTH) return notEnoughRealWords;

  const words = getWords(trimmed);
  if (
    words.length < OTHER_CANCELLATION_REASON_MIN_WORDS ||
    countDistinctWords(words) < OTHER_CANCELLATION_REASON_MIN_WORDS
  ) {
    return notEnoughRealWords;
  }

  return { valid: true };
};
